class KlaviyoBIS extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    setTimeout(() => {
      this.initializeComponent();
    }, 0);
  }

  initializeComponent() {
    let formValidated = [];

    const trigger = this.querySelector('.klaviyo-bis-trigger');
    const modalOverlay = this.querySelector('.klaviyo-bis-modal-overlay');

    if (!trigger || !modalOverlay) {
      return;
    }

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      modalOverlay.classList.add('flex');
      modalOverlay.classList.remove('hidden');
    });

    const closeModal = () => {
      modalOverlay.classList.add('hidden');
      modalOverlay.classList.remove('flex');

      const trigger = this.querySelector('.klaviyo-bis-trigger');
      if (trigger) {
        trigger.classList.remove('disabled');
      }
    };

    const closeButtons = this.querySelectorAll('.klaviyo-bis-close');
    closeButtons.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });

    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modalOverlay.classList.contains('hidden')) {
        closeModal();
      }
    });

    const handleNotifyMe = () => {
      const inputs = this.querySelectorAll('input');

      const uniqueInputs = [];
      const inputMap = new Map();

      inputs.forEach((input) => {
        if (input.id) {
          inputMap.set(input.id, input);
        } else {
          uniqueInputs.push(input);
        }
      });

      inputMap.forEach((input) => {
        uniqueInputs.push(input);
      });

      uniqueInputs.forEach((e, index) => {
        const isValid = e.reportValidity();
        if (isValid == false) {
          formValidated[index] = false;
        } else {
          formValidated[index] = true;
        }
      });

      let checker = (arr) => arr.every(Boolean);
      const isFormValid = checker(formValidated);

      if (isFormValid == false) {
        return;
      }

      const emailInput = uniqueInputs.find(
        (input) => input.id === 'email' && input.type === 'email'
      );
      const email = emailInput ? emailInput.value : '';
      const variantId = this.getAttribute('variant-id');

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15',
        },
        body: JSON.stringify(payload),
      };

      fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Ntc5BJ',
        requestOptions
      )
        .then(async (result) => {
          if (result.ok) {
            const completedMessage = this.querySelector('#completed_message');

            if (completedMessage) {
              document
                .querySelectorAll('#completed_message')
                .forEach((msg) => {
                  if (msg !== completedMessage) {
                    msg.classList.add('hidden');
                  }
                });

              completedMessage.classList.remove('hidden');

              setTimeout(() => {
                closeModal();
              }, 2000);
            }
          }
        })
        .catch(() => {});
    };

    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        handleNotifyMe();
      });
    }

    const notifyButton = this.querySelector(
      '.btn-notify, button[type="submit"]'
    );
    if (notifyButton) {
      notifyButton.addEventListener('click', (e) => {
        e.preventDefault();
        handleNotifyMe();
      });
    }
  }
}

customElements.define('klaviyo-bis', KlaviyoBIS);
